import React, { useEffect } from "react";

import "aos/dist/aos.css";
import Aos from "aos";

const MoreLight = (props) => {
    return (
        <div data-aos='zoom-out' className="col-12 col-xl-6 mx-auto text-warning">
          <div className="col">
            <h1 className="display-3 text-3f4448 btn-title">{props.title}</h1>
          </div>
          <ul id="Description" className="recrutation-description text-5a6369 px-3">
          {props.list}
          </ul>
        </div>
      );
    };

export default MoreLight
